export const common = {
  system_name: "广东省国际文化交流中心",
  time_full: `{y}年{m}月{d}日`,
  search: '搜索',
  back: '返回',
  see_more: '查看更多',
  search_empty: '抱歉，没有搜索到相关内容',
  content_empty: '暂无更多内容',
  week: {
    w0: '星期天',
    w1: '星期一',
    w2: '星期二',
    w3: '星期三',
    w4: '星期四',
    w5: '星期五',
    w6: '星期六',
  },
  month: {
    m1: '01',
    m2: '02',
    m3: '03',
    m4: '04',
    m5: '05',
    m6: '06',
    m7: '07',
    m8: '08',
    m9: '09',
    m10: '10',
    m11: '11',
    m22: '12',
  },
}
// 菜单
export const menu = {
  home: '首页',
  intro: '中心介绍',
  brief: '简介',
  organization: '理事会',
  rule: '章程',

  news: '文化要闻',
  moments: '中心动态',
  exchange: '文化交流',
  council: '理事风采',
  council_intro: '理事介绍',
  council_demeanour: '理事风采',
  council_composition: '理事名作',


  rostrum: '名家讲坛',
  
  search: '搜索结果',
}
// 职称
export const staff = {
  honorary_chairman: '名誉理事长',
  chairman: '理事长',
  vice_chairman: '副理事长',
  counselor: '顾问',
  honorary_vice_chairman: '名誉副理事长',
  council: '理事',
  history_council: '历届理事',
  secretary_general: '秘书长',
}
// 底部
export const footer = {
  link: '友情链接',
  address: '地址',
  phone: '电话',
  email: '邮箱',
}

// 文章
export const art = {
  time: '时间',
  author: '作者',
  source: '来源',
}
